import { useEffect, useState } from "react";
import { Box, Flex, useToast } from "@chakra-ui/react";
import { Modal } from "../../Modal";
import { ButtonCustom } from "../../../form/controls/form.button";
import { FormInput } from "../../../form/controls/form.input";
import { integrationService } from "../../../../service/integrations/integration.service";
import { successToast } from "../../../../constants/toast.constants";
import { useDispatch } from "react-redux";
import { deleteIntegration } from "../../../../store/slice/Account/user-profile.slice";

export const EditIntegrationModal = ({
  isOpen,
  onClose,
  onSubmit,
  integration,
}) => {
  const toast = useToast();
  const dispatch = useDispatch();
  
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    apiKey: null,
    apiUrl: integration?.apiUrl,
  });

  const onInputChange = (event: any) => {
    let { name, value } = event.target;

    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (integration?.status === "ISSUE") {
        await integrationService.updateIntegration(integration.id, formState);
      } else {
        await integrationService.deleteIntegration(integration.id);
        dispatch(deleteIntegration(integration.target));
      }

      toast(successToast(`Integration has been successfully updated!`));
      setLoading(false);
      onSubmit();
    } catch (error) {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setLoading(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      header="Manage Integration"
      onClose={loading ? null : handleClose}
    >
      <InfoBox status={integration?.status} />
      <form onSubmit={handleSubmit}>
        <Flex flexDir="column" gap="12px">
          {integration?.status === "ISSUE" && (
            <>
              <FormInput
                required
                name="apiUrl"
                title="API URL"
                placeholder="yourcompany.api.kandji.io"
                defaultValue={integration?.apiUrl}
                onChange={onInputChange}
              />
              <FormInput
                required
                type="password"
                name="apiKey"
                title="API Token"
                placeholder="Enter new API Token"
                onChange={onInputChange}
              />
            </>
          )}

          <Flex mt="12px" gap="12px" justifyContent="flex-end">
            <ButtonCustom
              secondary
              neutral
              onClick={handleClose}
              disabled={loading}
            >
              Close
            </ButtonCustom>
            <ButtonCustom
              type="submit"
              danger={integration?.status === "ACTIVE"}
              loading={loading}
              disabled={loading}
            >
              {integration?.status === "ISSUE"
                ? "Update Key"
                : "Delete Integration"}
            </ButtonCustom>
          </Flex>
        </Flex>
      </form>
    </Modal>
  );
};

const InfoBox = ({ status }) => {
  const isIssue =
    status === "issue" || status === "error" || status === "failed";

  return (
    <Box
      color={isIssue ? "red.500" : "green.500"}
      bgColor={isIssue ? "red.100" : "green.100"}
      fontSize="14px"
      mb="12px"
      p="12px"
      borderRadius="8px"
    >
      {isIssue
        ? "Failed to verify the API Key. Please enter a new key and try again."
        : "Integration is active and working properly."}
    </Box>
  );
};
